/**
 * Parish / district labels per island — mirrors backend island_divisions.py.
 * Used for instant UI when tourist switches island (no API wait).
 */
export const ISLAND_DIVISIONS = {
  barbados: {
    label: "Parish",
    items: [
      "Christ Church",
      "St. Michael",
      "St. James",
      "St. Peter",
      "St. Lucy",
      "St. Joseph",
      "St. Andrew",
      "St. Thomas",
      "St. John",
      "St. George",
      "St. Philip",
    ],
  },
  jamaica: {
    label: "Parish",
    items: [
      "Kingston",
      "St. Andrew",
      "Portland",
      "St. Thomas",
      "St. Mary",
      "St. Ann",
      "Trelawny",
      "St. James",
      "Hanover",
      "Westmoreland",
      "St. Elizabeth",
      "Manchester",
      "Clarendon",
      "St. Catherine",
    ],
  },
  trinidad: {
    label: "Region",
    items: ["Port of Spain", "San Fernando", "Chaguanas", "Arima", "Tobago", "Maracas", "Mayaro"],
  },
  bahamas: {
    label: "Island",
    items: ["New Providence", "Grand Bahama", "Exuma", "Harbour Island", "Eleuthera", "Abaco"],
  },
  stlucia: {
    label: "Quarter",
    items: ["Gros Islet", "Castries", "Soufrière", "Vieux Fort", "Dennery", "Micoud"],
  },
  antigua: {
    label: "Parish",
    items: ["St. John", "St. George", "St. Mary", "St. Paul", "St. Peter", "Barbuda"],
  },
  grenada: {
    label: "Parish",
    items: ["St. George", "St. Andrew", "St. David", "St. Mark", "St. Patrick", "Carriacou"],
  },
  stvincent: {
    label: "Parish",
    items: ["St. George", "Grenadines", "Charlotte", "St. Andrew"],
  },
  dominica: {
    label: "Parish",
    items: ["Roseau", "St. George", "St. Patrick", "St. Andrew", "St. David", "St. Paul"],
  },
  curacao: {
    label: "District",
    items: ["Willemstad", "Bandabou", "Bandariba", "Banda Abou"],
  },
  aruba: {
    label: "District",
    items: ["Oranjestad", "Noord", "Santa Cruz", "Savannah", "San Nicolas"],
  },
  cayman: {
    label: "District",
    items: ["George Town", "West Bay", "Bodden Town", "East End", "North Side", "Cayman Brac"],
  },
  usvi: {
    label: "Island",
    items: ["St. Thomas", "St. John", "St. Croix"],
  },
  bvi: {
    label: "Island",
    items: ["Tortola", "Virgin Gorda", "Jost Van Dyke", "Anegada"],
  },
  puerto_rico: {
    label: "Region",
    items: ["San Juan", "Rincón", "Ponce", "Vieques", "Culebra", "El Yunque", "Río Grande"],
  },
};

export function getIslandDivisions(countryCode) {
  const code = (countryCode || "").toLowerCase().trim();
  const meta = ISLAND_DIVISIONS[code] || { label: "Area", items: [] };
  return {
    country: code,
    division_label: meta.label,
    divisions: [...meta.items],
  };
}

export function mergeDivisionList(countryCode, fromPins = []) {
  const shell = getIslandDivisions(countryCode);
  const merged = new Set([...shell.divisions, ...fromPins.filter(Boolean)]);
  return {
    division_label: shell.division_label,
    divisions: [...merged].sort((a, b) => a.localeCompare(b)),
  };
}
